export let Code = {
type: `@Component({
    selector: 'p-panelMenu',
    template:
        <p-panelMenu [model]="items" [style]="{'width':'300px'}"></p-panelMenu>
})
export class PanelMenu {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/panelmenu.ts